import { WEB_APPS_BY_ID, WEB_APPS_LIST, WebAppIds } from "../types.js";
import { rpc } from "../../AuthWrapper2/rpc-bridge.js";
import { AuthViewModel } from "../../AuthWrapper2/viewmodels/AuthViewModel.js";
import { onBrowserVisibilityChange } from "@therms/web-js";
import { ViewModel, singleton } from "mvc-kit";
// src/modules/AppWrapper2/viewmodels/AppShellViewModel.tsx
var ALL_APP_PICKER_APPS = [
	WebAppIds.Ops,
	WebAppIds.Admin,
	WebAppIds.Portal,
	WebAppIds.Scheduling,
	WebAppIds.Dispatch,
	WebAppIds.Profile
];
var AppShellViewModel = class extends ViewModel {
	static DEFAULT_STATE = {
		appInteractionHandlers: null,
		appURLOverride: null,
		currentAppId: "",
		currentAppOverride: null,
		mapboxToken: ""
	};
	authVM = singleton(AuthViewModel);
	get identityInfo() {
		return this.authVM.state.identityInfo;
	}
	get organization() {
		return this.identityInfo?.organization ?? null;
	}
	get user() {
		return this.identityInfo?.user ?? null;
	}
	get currentApp() {
		const found = WEB_APPS_BY_ID[this.state.currentAppId];
		if (found) return found;
		if (this.state.currentAppOverride) return this.state.currentAppOverride;
	}
	get appPickerAvailableAppIds() {
		const org = this.organization;
		if (!org) return [];
		let appIds = [...ALL_APP_PICKER_APPS];
		if (!org.modules.dispatch) appIds = appIds.filter((id) => id !== WebAppIds.Dispatch);
		if (!org.modules.scheduling) appIds = appIds.filter((id) => id !== WebAppIds.Scheduling);
		if (org.integrations?.sentinel) appIds.push(WebAppIds.IntegrationSentinel);
		return appIds;
	}
	get appList() {
		const user = this.user;
		if (!user) return [];
		const availableIds = this.appPickerAvailableAppIds;
		if (user.superAdmin) return WEB_APPS_LIST.filter((app) => availableIds.includes(app.id));
		return availableIds.reduce((acc, appId) => {
			if (appId !== WebAppIds.Profile && !user.anp.roles.includes(appId)) return acc;
			const app = WEB_APPS_LIST.find(({ id }) => appId === id);
			if (app) {
				const link = this.state.appURLOverride?.[app.id] || app.link;
				acc.push({
					...app,
					link
				});
			}
			return acc;
		}, []);
	}
	get appPickerList() {
		return this.appList.filter((app) => app.id !== WebAppIds.Profile);
	}
	get hasAccessToCurrentApp() {
		const user = this.user;
		if (!user) return false;
		if (this.state.currentAppId === "profile") return true;
		if (user.superAdmin) return true;
		const currentApp = this.currentApp;
		if (!currentApp?.id) return false;
		return user.anp.roles.includes(currentApp.id);
	}
	get hasAnyApps() {
		const user = this.user;
		if (!user) return false;
		if (user.superAdmin) return true;
		return this.appList.length > 0;
	}
	get isClientAccessBlocked() {
		return !!this.organization?.clientAccess?.blocked;
	}
	onInit() {
		const { rpcClient } = rpc();
		console.info("AppShellViewModel connecting RPC websocket");
		rpcClient.transports().websocket?.connect();
		this.addCleanup(() => {
			console.info("AppShellViewModel disconnecting RPC websocket");
			rpcClient.transports().websocket?.disconnect();
		});
		let visibilityTimeout;
		const unsubVisibility = onBrowserVisibilityChange((visible) => {
			clearTimeout(visibilityTimeout);
			if (!visible) visibilityTimeout = setTimeout(() => {
				if (rpcClient.transports().websocket?.isConnected()) {
					rpcClient.transports().websocket?.disconnect();
					console.info("Disconnecting RPC WebSocket from 20m client visibility timeout");
				}
			}, 12e5);
			else {
				if (!rpcClient.transports().websocket?.isConnected()) {
					rpcClient.transports().websocket?.connect();
					console.info("Connecting RPC WebSocket from regaining client visibility");
				}
				clearTimeout(visibilityTimeout);
			}
		});
		this.addCleanup(() => {
			clearTimeout(visibilityTimeout);
			unsubVisibility();
		});
		const authVM = this.authVM;
		this.subscribeTo(authVM, () => {
			if (authVM.state.identityInfo) this.emit("identityChanged", authVM.state.identityInfo);
		});
	}
	syncConfig(config) {
		const partial = {};
		if (config.currentAppId !== void 0 && config.currentAppId !== this.state.currentAppId) partial.currentAppId = config.currentAppId;
		if (config.appInteractionHandlers !== void 0) partial.appInteractionHandlers = config.appInteractionHandlers;
		if (config.appURLOverride !== void 0) partial.appURLOverride = config.appURLOverride;
		if (config.currentAppOverride !== void 0) partial.currentAppOverride = config.currentAppOverride;
		if (config.mapboxToken !== void 0) partial.mapboxToken = config.mapboxToken;
		if (Object.keys(partial).length > 0) this.set(partial);
	}
	setCurrentAppId(currentAppId) {
		this.set({ currentAppId });
	}
	setMapboxToken(mapboxToken) {
		this.set({ mapboxToken });
	}
};
export { AppShellViewModel };

//# sourceMappingURL=AppShellViewModel.js.map